export default {
	options: [{
		value: '0',
		label: '上海速元科技有限公司'
	}, {
		value: '1',
		label: '上海速元科技有限公司'
	}],

	searchlist: [{
			prop: "nsrmc",
			label: '公司主体',
			type: "input"
		},{
		prop: "nsrsbh",
		label: '纳税人识别号',
		type: "input"
		},
		{
			prop: "period",
			label: '税款所属期',
			type: "datemonth",
			valueformat: 'yyyyMM'
		}
	],
	tableData: [],
	searchdata: {
		nsrmc: "",
		declareType: "",
		taxItem: "",
		specificItem: "",
		taxPeriod: "",
	},
	headData: [{
		title: "纳税人识别号",
		prop: "nsrsbh",
		width: 160,
	}, {
		title: "所属期",
		prop: "period",
		width: 100,
	}, {
		title: "已认证发票张数",
		prop: "invoiceNum",
		width: 80,
	}, {
		title: "不含税金额合计",
		prop: "amountExcludingTax",
		width: 80,
	}, {
		title: "税额合计",
		prop: "taxAmount",
		width: 80,
	},{
		title: "操作",
		prop: "cz",
		width: "200",
		fixed:"right",
		custom:true
	},],
	outputData: {
		exportType: "",
		shenbq: "",
	},
	pagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey: 0
	}
}
